export const COMPONENT_NAME = "wallet-crypto-new";
